import { Link, useLocation } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { VEILLE_COMMERCIALE } from "@/config/siteFlags";

/**
 * HeroActions — discreet 3-link secondary navigation rendered under the
 * hero intro on every main page. Same visual treatment as the existing
 * Comprendre hero ("Voir les services / Voir la méthode / Demander un
 * audit initial").
 *
 * The third action is "Demander un audit initial" on every page except
 * /audit-initial itself, which uses "Retour à l'accueil" instead.
 */

const ROUTE_ACTIONS = {
  "/": [
    { to: "/methode", label: "Voir la méthode" },
    { to: "/services", label: "Voir les services" },
  ],
  "/comprendre": [
    { to: "/services", label: "Voir les services" },
    { to: "/methode", label: "Voir la méthode" },
  ],
  "/methode": [
    { to: "/services", label: "Voir les services" },
    { to: "/cadre-juridique", label: "Voir le cadre juridique" },
  ],
  "/services": [
    { to: "/methode", label: "Voir la méthode" },
    { to: "/cadre-juridique", label: "Voir le cadre juridique" },
  ],
  "/cadre-juridique": [
    { to: "/methode", label: "Voir la méthode" },
    { to: "/services", label: "Voir les services" },
  ],
  "/outil-interne": [
    { to: "/methode", label: "Voir la méthode" },
    { to: "/services", label: "Voir les services" },
  ],
  "/audit-initial": [
    { to: "/services", label: "Voir les services" },
    { to: "/methode", label: "Voir la méthode" },
  ],
};

const TERMINAL = {
  to: "/audit-initial",
  label: "Demander un audit initial",
};

const AUDIT_TERMINAL = { to: "/", label: "Retour à l'accueil" };

export default function HeroActions({ pathname, delay = 180 }) {
  const location = useLocation();
  const key = pathname || location.pathname;
  const pair = ROUTE_ACTIONS[key];
  if (VEILLE_COMMERCIALE || !pair) return null;

  const terminal = key === "/audit-initial" ? AUDIT_TERMINAL : TERMINAL;
  const links = [...pair, terminal];

  return (
    <div
      data-testid="hero-actions"
      className="mt-10 flex flex-wrap items-center gap-x-8 gap-y-3 animate-fade-up"
      style={{ animationDelay: `${delay}ms` }}
    >
      {links.map((l) => (
        <Link
          key={l.to + l.label}
          to={l.to}
          data-testid={`hero-action-${l.to.replace(/\W+/g, "-").replace(/^-|-$/g, "") || "home"}`}
          className="text-[12px] font-semibold text-[#181A1D] hover:text-[#B83A34] transition-colors duration-200 inline-flex items-center gap-2"
        >
          {l.label}
          <ArrowUpRight size={13} strokeWidth={1.5} />
        </Link>
      ))}
    </div>
  );
}
